'use strict';

import React, { Component } from 'react';
import { injectStripe, PaymentRequestButtonElement } from 'react-stripe-elements';

import Spinner from 'ck-core-client/source/components/Spinner';
import { STRIPE_STATUS } from 'ck-core/source/data/StripeStatus';
import { completeSca } from 'ck-website/source/functions/completeSca';

class StripePaymentButton extends Component {
	constructor(props) {
		super(props);
		this.state = {
			canMakePayment: false,
			paymentRequest: {},
			loading: true
		};
	}
	componentDidMount() {
		const { currency, price, planId, handleSubmit } = this.props;
		this.generatePaymentRequest(currency, price, planId, handleSubmit);
	}

	generatePaymentRequest(currency, price, planId, handleSubmit) {
		const stripe = window.Stripe(CK.config.environment.STRIPE_PUBLISHABLE_KEY);
		this.setState({
			canMakePayment: false,
			paymentRequest: {},
			loading: true
		});
		const paymentRequest = stripe.paymentRequest({
			country: 'GB',
			currency: currency,
			total: {
				label: planId,
				amount: price
			}
		});
		paymentRequest.on('paymentmethod', async ev => {
			try {
				const paymentMethod = {
					stripeResponse: {
						id: ev.paymentMethod.id
					}
				};
				const { request, result } = await handleSubmit(paymentMethod, true);

				if (result.status === STRIPE_STATUS.INCOMPLETE) {
					await completeSca(result.purchaseId, result.paymentIntentClientSecret);
				}

				await this.props.handleSuccess(request, result);
				ev.complete('success');
			} catch (err) {
				CK.logger.warn(err);
				ev.complete('fail');
			}
		});

		paymentRequest.canMakePayment().then(result => {
			this.setState({
				canMakePayment: !!result,
				paymentRequest: paymentRequest,
				loading: false,
				currency: currency
			});
		});
	}

	render() {
		const { loading, canMakePayment, paymentRequest, currency } = this.state;
		const { price, planId, handleSubmit, validEmail, handleInvalidClick } = this.props;
		if (loading) return <Spinner />;
		if (currency !== this.props.currency) {
			this.generatePaymentRequest(this.props.currency, price, planId, handleSubmit);
		}
		return canMakePayment && paymentRequest ? (
			<PaymentRequestButtonElement
				className="PaymentRequestButton"
				paymentRequest={paymentRequest}
				onClick={e => {
					if (!validEmail) {
						handleInvalidClick();
						e.stopPropagation();
					}
				}}
			/>
		) : (
			<p> Sorry this payment method is unavailable for you currently</p>
		);
	}
}

export default injectStripe(StripePaymentButton);
